import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/providers/StoreProvider';
import { GameState } from '../types';
import ImgPause from '@/shared/pictures/block_pause.png';
import {AREA} from "@/entities/game/model/gameLayout";


export const Pause = observer(() => {
    const { gameStore } = useStore();
    const {gameState} = gameStore;

    const width = AREA.width;

    if(gameState !== GameState.pause) {return null}
    return (
      <div className='block-pause' style={{width:width, height:AREA.height, borderRadius:46 * gameStore.scale}}>
        <p className='block-pause_text'>Игра на паузе</p>
      </div>
    );

});